import React from 'react'

const PlanIcon = (plan_name: any) => {
  return (
    <svg
      width="53"
      height="54"
      viewBox="0 0 53 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.210938"
        y="0.984375"
        width="52.1053"
        height="52.1053"
        rx="26.0526"
        fill={plan_name === "Professional" ? "white" : "#0A012E"}
      />
      <path
        d="M27.3505 16.1797L17.6822 27.7816C17.3036 28.236 17.1143 28.4632 17.1114 28.6551C17.1089 28.8219 17.1832 28.9805 17.3129 29.0854C17.4622 29.206 17.7579 29.206 18.3494 29.206H26.265L25.1795 37.8902L34.8478 26.2883C35.2264 25.8339 35.4157 25.6067 35.4186 25.4148C35.4211 25.248 35.3468 25.0894 35.2171 24.9845C35.0678 24.8639 34.7721 24.8639 34.1806 24.8639H26.265L27.3505 16.1797Z"
        stroke={plan_name === "Professional" ? "#0A012E" : "white"}
        strokeWidth="2.17105"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default PlanIcon